function readInjectedKey(elementId) {
    const el = document.getElementById(elementId);
    if (!el) return '';
    try {
        return JSON.parse(el.textContent) || '';
    } catch (e) {
        return '';
    }
}

export const getLoginRecaptchaKey = () => readInjectedKey('recaptcha-login-site-key');
export const getResetRecaptchaKey = () => readInjectedKey('recaptcha-reset-site-key');
